import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  FaFacebookF, FaInstagram, FaTripadvisor, FaWhatsapp,
  FaYoutube, FaMapMarkerAlt, FaPhone, FaEnvelope,
  FaHeart, FaCompass, FaStar, FaUmbrellaBeach,
  FaMountain, FaWater, FaTree
} from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import { FaXTwitter } from 'react-icons/fa6';
import './footer.css';

const Footer = () => {
  const { t } = useTranslation('flysafari');

  return (
    <footer className="footer-premium">
      
      {/* MAIN FOOTER GRID */}
      <div className='footer-grid'>
        
        {/* BRAND COLUMN */}
        <div className='footer-column brand-column'>
          <div className="brand-identity">
          
            <div className="brand-content">
              <h3 className="brand-title">Olenini Tours & Safaris</h3>
              <p className="brand-mission">
                Discover East Africa's wonders through authentic Maasai guidance, where expert wildlife 
                tracking and cultural immersion create unforgettable adventures - with each journey 
                supporting the Osiligi Medical Foundation.
              </p>
            </div>
          </div>

          {/* IMPACT STATEMENT */}
         <Link to="/osiligi" className="impact-card-link">
  <div className="impact-card">
    <div className="impact-header">
      <FaHeart className="impact-icon" />
      <span className="impact-title">Travel with Purpose</span>
    </div>
    <p className="impact-text">
      Every safari supports the Osiligi Medical Foundation serving 50,000+ in Maasai communities
    </p>
  </div>
</Link>

          {/* ACTION BUTTONS */}
  
           
        </div>

        {/* SAFARI EXPERIENCES COLUMN */}
        <div className='footer-column experiences-column'>
          <h4 className="column-title">Safari Experiences</h4>
          <nav className="footer-nav">
            <Link to="/Mara-DeepDive" className="nav-item">
              <FaStar className="nav-icon" />
              <div className="nav-content">
                <span className="nav-title">Maasai Mara Safari</span>
                <span className="nav-subtitle">Big Five & Migration</span>
              </div>
            </Link>
            <Link to="/Kenya-Classic" className="nav-item">
              <FaHeart className="nav-icon" />
              <div className="nav-content">
                <span className="nav-title">Kenya Classic Tour</span>
                <span className="nav-subtitle">Ultimate First Timer's Safari</span>
              </div>
            </Link>
            <Link to="/Osiligi-Clinic-Safari" className="nav-item">
              <FaHeart className="nav-icon" />
              <div className="nav-content">
                <span className="nav-title">Medical Volunteer</span>
                <span className="nav-subtitle">Safari with Purpose</span>
              </div>
            </Link>
            <Link to="/Bush-BeachSafari" className="nav-item">
              <FaCompass className="nav-icon" />
              <div className="nav-content">
                <span className="nav-title">Bush and Beach Safari</span>
                <span className="nav-subtitle">In-depth wildlife & slow coastal days</span>
              </div>
            </Link>
          </nav>
        </div>

        {/* DESTINATIONS COLUMN */}
        <div className='footer-column destinations-column'>
          <h4 className="column-title">Wilderness Destinations</h4>
          <nav className="footer-nav">
            <Link to="/places/mara" className="nav-item">
              <FaUmbrellaBeach className="nav-icon" />
              <span className="nav-title">Maasai Mara</span>
            </Link>
            <Link to="/places/amboseli" className="nav-item">
              <FaMountain className="nav-icon" />
              <span className="nav-title">Amboseli</span>
            </Link>
            <Link to="/places/nakuru" className="nav-item">
              <FaWater className="nav-icon" />
              <span className="nav-title">Lake Nakuru</span>
            </Link>
            <Link to="/places/shela" className="nav-item">
              <FaTree className="nav-icon" />
              <span className="nav-title">Shela Beach</span>
            </Link>
            
            <Link to="/customizesafari" className="btn-secondary">
              <FaCompass size={12} />
               <span className="nav-title">Design Your Safari</span>
            </Link>
          
          </nav>
        </div>

        


        {/* CONTACT COLUMN */}
        <div className='footer-column contact-column'>
          <h4 className="column-title">Start Your Journey</h4>
          
          {/* CONTACT METHODS */}
          <div className="contact-methods">
        
            <div className="contact-item">
              <FaPhone className="contact-icon phone" />
              <div className="contact-details">
                <span className="contact-label">Call Direct</span>
                <a href="tel:+254702965315" className="contact-value">
                  +254 702 965 315
                </a>
              </div>
            </div>
            
            <div className="contact-item">
              <FaEnvelope className="contact-icon email" />
              <div className="contact-details">
                <span className="contact-label">Email</span>
                <a href="mailto:info@oleninisafaris.com" className="contact-value">
                  info@oleninisafaris.com
                </a>
              </div>
            </div>
            
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon location" />
              <div className="contact-details">
                <span className="contact-label">Location</span>
                <span className="contact-value">Narok, Kenya</span>
              </div>
            </div>
          </div>

          {/* SOCIAL LINKS - CURATED SELECTION */}
          <div className="social-section">
            <h5 className="social-title">Connect With Us</h5>
            <div className="social-grid">
              <a href="https://www.instagram.com/olenininisafaris" className="social-link">
                <FaInstagram />
              </a>
              <a href="https://www.facebook.com/oleninisafaris" className="social-link">
                <FaFacebookF />
              </a>
              <a href="https://www.youtube.com/@Oleninisafaris-tours" className="social-link">
                <FaYoutube />
              </a>
              <a href="https://www.tripadvisor.in/Attraction_Review-g1026010-d33960431-Reviews-Olenini_Safaris-Narok_Rift_Valley_Province.html" className="social-link">
                <FaTripadvisor />
              </a>
              <a href="https://x.com/olenini_safaris" className="social-link">
                <FaXTwitter />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER BOTTOM */}
      <div className="footer-bottom">
        <div className="footer-copyright">
          <p>© {new Date().getFullYear()} Olenini Tours & Safaris. All rights reserved.</p>
        </div>
      </div>

      {/* PREMIUM FLOATING WHATSAPP */}
      <a
        href="https://wa.me/254702965315?text=Hello%20Olenini%20Safaris,%20I'd%20like%20to%20plan%20my%20dream%20safari%20adventure!"
        className="premium-whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
      >
        <div className="whatsapp-container">
          <FaWhatsapp className="whatsapp-icon" />
          <div className="pulse-ring"></div>
        </div>
      </a>
    </footer>
  );
};

export default Footer;